<div class="remove-scroll">
    <app-navigation-header header="LEGAL_TERMS.TITLE" icon="fa-solid fa-gavel"> </app-navigation-header>
    <div class="legal-container">
        <div class="legal-sub-container">
            <h1>{{ "LEGAL_TERMS.READ" | translate }}</h1>
            <a [href]="termsAndConditionsUrl$ | async" target="_blank">
                <button
                    pButton
                    pRipple
                    [title]="'LEGAL_TERMS.TERMS_AND_CONDITIONS.TITLE' | translate"
                    [label]="'LEGAL_TERMS.TERMS_AND_CONDITIONS.TITLE' | translate"
                    type="button"
                    class="p-button-rounded"
                    tooltipPosition="top"
                ></button>
            </a>
            <a [href]="termsOfSalesUrl$ | async" target="_blank">
                <button
                    pButton
                    pRipple
                    [title]="'LEGAL_TERMS.TERMS_OF_SALES.TITLE' | translate"
                    [label]="'LEGAL_TERMS.TERMS_OF_SALES.TITLE' | translate"
                    type="button"
                    class="p-button-rounded"
                    tooltipPosition="top"
                ></button>
            </a>
            <a [href]="privacyPolicyUrl$ | async" target="_blank">
                <button
                    pButton
                    pRipple
                    [title]="'LEGAL_TERMS.PRIVACY_POLICY.TITLE' | translate"
                    [label]="'LEGAL_TERMS.PRIVACY_POLICY.TITLE' | translate"
                    type="button"
                    class="p-button-rounded"
                    tooltipPosition="top"
                ></button>
            </a>
        </div>
    </div>
</div>
